import { ButtonModule } from './../button/button.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationConfirmationComponent } from './components/donation-confirmation/donation-confirmation.component';
import { SharedModule } from '../../shared/shared.module';
import { DonationConfirmationSheetComponent } from './components/donation-confirmation-sheet/donation-confirmation-sheet.component';
import { DownloadAppBannerModule } from '../download-app-banner/download-app-banner.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ButtonModule,
    DownloadAppBannerModule,
    MatButtonModule
  ],
  declarations: [DonationConfirmationComponent, DonationConfirmationSheetComponent],
  exports: [DonationConfirmationComponent]
})
export class DonationConfirmationModule { }
